import { cilPlus } from "@coreui/icons";
import CIcon from "@coreui/icons-react";
import {
  CButton,
  CCard,
  CCardBody,
  CCol,
  CForm,
  CFormInput,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
  CRow,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from "@coreui/react";
import { useMutation, useQuery } from "@tanstack/react-query";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { FaEdit, FaTrash } from "react-icons/fa";
import CustomPagination from "src/components/CustomPagination";
import {
  createType,
  deleteType,
  getAllTypeService,
  getSingleType,
  updateType,
} from "src/services/type.services";

const ManageTypes = () => {
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [name, setName] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedTypeId, setSelectedTypeId] = useState("");

  const { register, handleSubmit, reset, setValue } = useForm({
    defaultValues: {
      name: "",
    },
  });

  const {
    data: TypesQueryData,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: ["type", currentPage, limit],
    queryFn: () => getAllTypeService({ name, page: currentPage }),
    enabled: true,
  });

  const { data: SingleTypeQueryData, isLoading: singleTypeLoading } = useQuery({
    queryKey: `singleType-${selectedTypeId}`,
    queryFn: () => getSingleType(selectedTypeId),
    enabled: !!selectedTypeId,
  });

  const createMutation = useMutation({
    mutationKey: ["createType"],
    mutationFn: (data) => createType(data),
    onMutate: (data) => {
      toast.loading("Creating...");
    },
    onSuccess: (res) => {
      toast.dismiss();
      if (res.success) {
        reset();
        refetch();
        setShowModal(false);
        setSelectedTypeId(null);
        toast.success("Unit created successfully");
      }
    },
    onError: (error) => {
      toast.dismiss();
      toast.error(error?.response?.data?.message || "Something went wrong!");
    },
  });

  const updateMutation = useMutation({
    mutationKey: ["updateType"],
    mutationFn: ({ id, data }) => updateType(id, data),
    onMutate: () => {
      toast.loading("Updating...");
    },
    onSuccess: (res) => {
      toast.dismiss();
      if (res.success) {
        const updateData = res.data;
        const index = data.findIndex((item) => item._id === updateData._id);
        if (index !== -1) {
          const updatedData = [...data];
          updatedData[index] = updateData;
          setData(updatedData);
        }
        reset();
        setShowModal(false);
        setSelectedTypeId(null);
        toast.success(res?.message || "Type updated successfully");
      }
    },
    onError: (error) => {
      toast.dismiss();
      toast.error(error?.response?.data?.message || "Something went wrong!");
    },
  });

  const deleteMutation = useMutation({
    mutationKey: ["deleteType"],
    mutationFn: (id) => deleteType(id),
    onMutate: () => {
      toast.loading("Deleting...");
    },
    onSuccess: (res) => {
      toast.dismiss();
      if (res.success) {
        refetch();
        toast.success(res?.message || "Type deleted successfully");
      }
    },
    onError: (error) => {
      toast.dismiss();
      toast.error(error?.response?.data?.message || "Something went wrong!");
    },
  });

  const handleModalAction = (e, id = null) => {
    e.preventDefault();
    if (id) {
      setSelectedTypeId(id);
    }

    setShowModal(true);
  };

  const handleCloseModal = () => {
    setSelectedTypeId(null);
    setShowModal(false);
  };
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const onFormSubmit = (data) => {
    console.log(data);
    if (selectedTypeId) {
      updateMutation.mutate({ id: selectedTypeId, data });
    } else {
      createMutation.mutate(data);
    }
  };

  useEffect(() => {
    if (!isLoading && TypesQueryData && TypesQueryData.success) {
      const resultData = TypesQueryData.data;
      setData(resultData);
    }
  }, [TypesQueryData, isLoading]);

  useEffect(() => {
    if (
      !singleTypeLoading &&
      SingleTypeQueryData &&
      SingleTypeQueryData.success
    ) {
      const resultData = SingleTypeQueryData.data;
      if (resultData) {
        setValue("name", resultData?.name);
      }
    }
  }, [SingleTypeQueryData, singleTypeLoading]);
  return (
    <>
      <CCard className="mb-4">
        <CCardBody>
          <CRow>
            <CCol sm={5}>
              <h4 id="traffic" className="card-title mb-0">
                Booking Order Types
              </h4>
            </CCol>
            <CCol sm={7} className="d-none d-md-block">
              <div className="d-flex justify-content-end">
                <CButton onClick={handleModalAction}>
                  <CIcon icon={cilPlus} />
                  &nbsp; Add Types
                </CButton>
              </div>
            </CCol>
          </CRow>
          <br />
          <CTable align="middle" className="mb-0 border" hover responsive>
            <CTableHead color="light">
              <CTableRow>
                <CTableHeaderCell className="text-center">No.</CTableHeaderCell>
                <CTableHeaderCell>Unit Name</CTableHeaderCell>
                <CTableHeaderCell>Action</CTableHeaderCell>
              </CTableRow>
            </CTableHead>
            <CTableBody>
              {isLoading ? (
                <CTableRow className="text-center">
                  <CTableDataCell colSpan="5">Loading...</CTableDataCell>
                </CTableRow>
              ) : data.length == 0 ? (
                <CTableRow className="text-center">
                  <CTableDataCell colSpan="5">No data available</CTableDataCell>
                </CTableRow>
              ) : (
                data.map((item, index) => (
                  <CTableRow v-for="item in tableItems" key={index}>
                    <CTableDataCell className="text-center">
                      <div>{index + 1}</div>
                    </CTableDataCell>

                    <CTableDataCell className="text-capitalize">
                      <div>{item.name}</div>
                    </CTableDataCell>
                    <CTableDataCell>
                      <div className="d-flex gap-3">
                        <CButton
                          variant="ghost"
                          color="warning"
                          shape="rounded-pill"
                          onClick={(e) => handleModalAction(e, item._id)}
                          style={{
                            padding: 0,
                            backgroundColor: "transparent",
                            border: 0,
                          }}
                        >
                          <FaEdit />
                        </CButton>
                        <CButton
                          variant="ghost"
                          color="danger"
                          shape="rounded-pill"
                          onClick={() => deleteMutation.mutate(item._id)}
                          style={{
                            padding: 0,
                            backgroundColor: "transparent",
                            border: 0,
                          }}
                        >
                          <FaTrash />
                        </CButton>
                      </div>
                    </CTableDataCell>
                  </CTableRow>
                ))
              )}
            </CTableBody>
          </CTable>
          <br />
          <CustomPagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </CCardBody>
      </CCard>

      <CModal visible={showModal} onClose={handleCloseModal}>
        <CModalHeader>
          <CModalTitle>Type Details</CModalTitle>
        </CModalHeader>

        <CModalBody>
          <CForm onSubmit={handleSubmit(onFormSubmit)}>
            <CFormInput
              type="text"
              id="name"
              placeholder="Unit Name"
              {...register("name", { required: true })}
              required
            />
            <div className="d-grid gap-2 d-md-flex justify-content-md-end mt-3">
              <CButton color="secondary" onClick={handleCloseModal}>
                Close
              </CButton>
              <CButton color="primary" type="submit">
                Save changes
              </CButton>
            </div>
          </CForm>
        </CModalBody>
      </CModal>
    </>
  );
};

export default ManageTypes;
